module.exports = __webpack_public_path__ + "img/指导师.db446c1b.jpg";